import React from "react";
import { Dialog, DialogContentText, DialogActions } from "@material-ui/core";
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";
import styled from "styled-components";

import { ReactComponent as Trash } from "../../../../../svgs/Trash.svg";

const ContentTextWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-content: center;
    padding: 1em 1em;
`;

const StyledDialogContentText = styled(DialogContentText)`&& {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  color: #102F54B2;
  width:228px;
}`;

const StyledSecondaryButton = styled.button`
  color: #005AA9;
  width: 132px;
  border: 1px solid #005AA9;
  border-radius: 10px;
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  width: 132px;
  height: 37px;
  background: #F7F7F7;
  cursor: pointer;
  border-width: 0.5px 0.5px 1px 0.5px;
  border-style: solid;
  border-color: #E1E1E1;
  border-radius: 10px;
`;

const DeleteButton = styled.button`
  border-radius:10px;
  background: linear-gradient(to bottom, #005AA9D9, #005AA9);
  width: 132px;
  height: 37px;
  color: #FFFFFF;
  border 1px solid #004989;
  cursor: pointer;
  border-radius:10px;
  font-family: 'IBM Plex Sans';
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
`;

const DialogMainTitle = styled.div`{
  font-family: 'Metropolis';
  color: #102F54CC;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  margin: 0 auto;
}`;

const TrashIconContainer = styled.div`
  margin: 0 auto;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const DeleteCampaignDialog = ({ open, handleNo, handleYes }) => (
  <Dialog
    PaperProps={{
      style: {
        padding: "1.5em"
      }
    }}
    open={open}
  >
    <TitleContainer>
      <TrashIconContainer>
        <Trash />
      </TrashIconContainer>
      <DialogMainTitle>Delete Mass Email</DialogMainTitle>
    </TitleContainer>
    <ContentTextWrapper>
      <StyledDialogContentText>Are you sure you want to delete this mass email? This cannot be undone.</StyledDialogContentText>
    </ContentTextWrapper>
    <DialogActions>
      <StyledSecondaryButton onClick={handleNo}>Cancel</StyledSecondaryButton>
      <DeleteButton onClick={handleYes}>Delete</DeleteButton>
    </DialogActions>
  </Dialog>
);

export default DeleteCampaignDialog;
